module.exports = __webpack_public_path__ + "static/media/10.f233ca63.jpg";